'use client';

import { useMemo } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export function useReadFullPath() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentFullPath = useMemo(
    () =>
      `${pathname}${searchParams.size > 0 ? '?' + searchParams.toString() : ''}`,
    [pathname, searchParams],
  );

  return currentFullPath;
}
